<template>
  <div :class="'kewen-theme-' + theme">
    <div v-if="theme === 'line'">
      {{entity.id}}.&nbsp;{{entity.title}} <span v-if="config && config.time">播放: {{beginTime}} - {{endTime}}</span>
    </div>
    <div v-else>
      <VideoView :src="entity.video" v-if="entity.video"></VideoView>
      <pinyin :list="entity.sentences"></pinyin>
      <div v-if="config && config.time">
        播放: {{beginTime}} - {{endTime}}
      </div>
    </div>
  </div>
</template>

<script>
import utils from './../../js/utils'
import pinyin from './../PinyinPreview'
import VideoView from './../VideoView'

export default {
  name: 'KewenPreview',
  components: { pinyin, VideoView },
  props: {
    entity: {
      type: Object,
      default: () => {
        return {
          content: ''
        }
      }
    },
    config: {
      type: Object,
      default () {
        return {}
      }
    },
    theme: {
      type: String,
      default: 'card'
    }
  },
  data () {
    return {}
  },
  computed: {
    beginTime () {
      return utils.asDuration(this.config.time[0])
    },
    endTime () {
      return utils.asDuration(this.config.time[1])
    }
  }
}
</script>
